import { connect } from "datocms-plugin-sdk";
import { render } from './utils/render';
import ConfigScreen from './entrypoints/ConfigScreen';
import ClassSelector from './components/TripClassSelect';
import 'datocms-react-ui/styles.css';

// Initialize the plugin and connect it to DatoCMS
connect({
  renderConfigScreen(ctx) {
    return render(<ConfigScreen ctx={ctx} />);
  },
  manualFieldExtensions(ctx) {
    return [
      {
        id: 'Trip Class Selector',
        // Mirror the installation's display name so the field-editor tile
        // always matches the Configuration > Plugins list ([Prev]/[Prod]).
        name: ctx.plugin.attributes.name || 'Trip Class Selector',
        type: 'editor',
        fieldTypes: ['json'],
      },
    ];
  },

  renderFieldExtension(id, ctx) {
    return render(<ClassSelector ctx={ctx} />);
  }
});
